import { render, staticRenderFns } from "./AgeRangeBar.vue?vue&type=template&id=651b972a&"
import script from "./AgeRangeBar.vue?vue&type=script&lang=js&"
export * from "./AgeRangeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports